import PropTypes from "prop-types";
import MDTypography from "components/MDTypography";

function DefaultCell({ value, suffix, width }) {
  return (
    <>
      {/* {width && (
        <style>
          {`
            .MuiBox-root .css-ekdnj9 {
              display: inline-block;
              width: 250px;
              opacity: 1;
              background: transparent;
              color: #7b809a;
              border-radius: 0;
              box-shadow: none;
              vertical-align: middle;
            }
          `}
        </style>
      )} */}

      <MDTypography variant="caption" fontWeight="medium" color="text" style={{ fontSize: "14px" }}>
        {value}
        {suffix && (
          <MDTypography variant="caption" fontWeight="medium" color="secondary">
            &nbsp;&nbsp;{suffix}
          </MDTypography>
        )}
      </MDTypography>
    </>
  );
}

// Setting default values for the props of DefaultCell
DefaultCell.defaultProps = {
  suffix: "",
  // width: "",
};

// Typechecking props for the DefaultCell
DefaultCell.propTypes = {
  value: PropTypes.string,
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  // width: PropTypes.string,
};

export default DefaultCell;
